<div class="container text-center checkout-info">
  <div class="checkout-info-overlay"></div>
  <div class="card">
    <div style="border-radius:200px; height:200px; width:200px; background: #F8FAF5; margin:0 auto;">
      <i class="checkmark">✓</i>
    </div>
    <h1>Success</h1>
    <p>We received your purchase request</p>
  </div>
</div>
